export function stripHtml(html = "") {
  return html
    .replace(/<style[\s\S]*?<\/style>/gi, " ")
    .replace(/<script[\s\S]*?<\/script>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function buildBlogExcerpt(blog, maxLength = 180) {
  const source = blog?.metaDescription || stripHtml(blog?.content || "");
  if (!source) return "";
  return source.length > maxLength
    ? `${source.slice(0, maxLength).trimEnd()}...`
    : source;
}

export function toBlogPreview(blog, maxLength = 180) {
  return {
    _id: blog?._id,
    blogId: blog?.blogId,
    slug: blog?.slug,
    title: blog?.title,
    displayImage: blog?.displayImage,
    excerpt: buildBlogExcerpt(blog, maxLength),
  };
}
